<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="أنفال-السعيد">
<h1><span dir="rtl">أنفال السعيد</span></h1>
<p style="text-indent:0em"><span dir="rtl">أنفال السعيد شخصية مرحة بسيطة، مُحِبَّة للطبيعة، انطوائية بعض الشيء، وُلِدَت ونشأَت في مملكة البحرين.</span></p>
<p style="text-indent:0em"><span dir="rtl">تحبُّ التجارب والمغامرات وحبَّ الاستطلاع، والاستكشاف الذَّاتي والنفسي.</span></p><br/>
<p style="text-indent:0em"><span dir="rtl">بدأَتِ الكتابة منذ الصِّغَر، ولكنها توَقَّفَت بعدها؛ لذا كانت تكتب على فترات متفاوتة.</span></p><br/>
<p style="text-indent:0em"><span dir="rtl">تتضَمَّن كتاباتها في أغلب الأوقات بعض الخواطر أو الجُمَل التحفيزيَّة، وهي أيضًا تهوَى الكتابة لدرجة أنَّها تراها ملاذها الوحيد وراحتها النفسيَّة، فهي تراها كأكثر مِن هِواية!</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1920de07